import clsx from 'clsx';
import { FunctionComponent } from 'react';

import styles from './ClientGroupsSubOptions.module.scss';

interface ClientGroupsSubOptionsProps {
    /** Ids of the tags currently picked in the "By Client Tag" drawer. */
    selectedTagIds: string[];
    /** Opens the `ChooseModal` for tag selection. */
    onOpenTagDrawer: () => void;
}

/**
 * Sub-options shown when the user picks "Client Groups" as their recipient
 * mode. Only "By Client Tag" is exposed today — the other filters (by pet
 * type, by date added, by activity) are planned for post-launch and hidden
 * until the backend supports them.
 *
 * The radio doubles as the trigger: clicking it opens the tag picker modal.
 * The radio shows filled once the user has at least one tag selected, so the
 * component reflects the actual state of the campaign draft.
 */
const ClientGroupsSubOptions: FunctionComponent<ClientGroupsSubOptionsProps> = ({
    selectedTagIds,
    onOpenTagDrawer
}) => {
    const hasTagsSelected = selectedTagIds.length > 0;

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>Select a Group</h3>

            <button
                type="button"
                className={clsx(styles.option, { [styles.selected]: hasTagsSelected })}
                onClick={onOpenTagDrawer}
            >
                <span className={styles.radio}>{hasTagsSelected && <span className={styles.radioDot} />}</span>
                <span className={styles.label}>
                    By Client Tag
                    {hasTagsSelected && <span className={styles.hint}> ({selectedTagIds.length} selected)</span>}
                </span>
            </button>
        </div>
    );
};

export default ClientGroupsSubOptions;
